import { BaseObj } from "../UserdataSync";
import { LeiStorage } from "./lei.storage";

export class LeiConteudo extends BaseObj {
  id: string;
  dados: string;
  dataHoraUltimaModificacaoTextoLei: Date;

  static fromStorage(lei: LeiStorage): LeiConteudo {
    return {
      id: lei.id,
      dados: lei.dados,
      dataHoraUltimaModificacaoTextoLei: lei.dataHoraUltimaModificacaoTextoLei,
      dataHoraModificacao: lei?.dataHoraModificacao,
      removido: lei?.removido,
    };
  }
}
